import { Activity, Copy, DangerTriangleSolid } from '@mynaui/icons-react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from './ui/button';

interface iFullPageLoaderProps {
  title?: string;
  subtitle?: string;
  error?: Error;
}

const FullPageError: FunctionComponent<iFullPageLoaderProps> = ({ title, subtitle, error }) => {
  const { t } = useTranslation('common');
  const _handleCopyError = () => {
    navigator.clipboard.writeText(`Message: ${error?.message}\nStack: ${error?.stack}`);
    toast.success(t('fullPageError.errorCopied'));
  };
  return (
    <div className='flex w-full h-full items-center justify-center bg-slate-50 dark:bg-stone-950'>
      <div className='flex flex-col items-center justify-center'>
        <DangerTriangleSolid className='size-8 text-rose-500' />
        <span className='font-semibold pt-4 text-slate-700 dark:text-white'>{title || t('fullPageError.error')}</span>
        <span className='text-xs text-slate-500 font-medium dark:text-white/70'>{subtitle}</span>

        {error && (
          <details className='mt-2 max-w-screen-md mt-4'>
            <summary className='cursor-pointer font-medium flex text-xs text-center text-slate-700 font-medium dark:text-white'>
              <span className='flex items-center gap-2'>
                <Activity className='size-4' />
                {t('fullPageError.showErrorDetails')}
              </span>
            </summary>
            <div className='border rounded-lg max-w-160 bg-white border-slate-200 mt-2 p-2 px-3 dark:bg-stone-900 dark:border-stone-700 overflow-auto'>
              <span className='block text-xs font-mono font-semibold'>{error?.message}</span>
              <span className='block text-xs text-slate-500 font-mono font-medium mt-1 max-h-40 overflow-y-auto dark:text-white/70'>
                {error?.stack}
              </span>
            </div>
            <Button variant='outline' className='mt-2 w-full' onClick={_handleCopyError}>
              <Copy className='size-4' />
              {t('fullPageError.copyError')}
            </Button>
          </details>
        )}
      </div>
    </div>
  );
};

export default FullPageError;
